import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-78a8c388"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "l-wrapper_main" }
const _hoisted_2 = { class: "p-login" }
const _hoisted_3 = { class: "p-login-inner" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "p-login-heading-1" }, "認証確認", -1))
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { class: "p-login-form__field" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "p-login-form__label",
  for: "verify-password"
}, "マイページパスワード", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  class: "p-login-form__toggle js-toggle-password",
  type: "button"
}, null, -1))
const _hoisted_9 = { class: "p-login-text-block" }
const _hoisted_10 = { class: "--is-centered" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "p-login-form__field" }, [
  /*#__PURE__*/_createElementVNode("button", {
    class: "p-login-button",
    type: "submit"
  }, "確認する")
], -1))

import { ref, onMounted, nextTick } from 'vue';
import { Form, Field, ErrorMessage } from 'vee-validate';
import { useRoute, useRouter } from 'vue-router';
import { MailSecurityVerifyResponse } from '@/types/emailSerurity';
import { postMailSecurityCheckKey, postMailSecurityVerifyWithPassword } from '@/api/accountEndpoint';
import { errorMessage } from '@/constants/validationErrors';
import Loading from '@/components/Loading.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'VerifyByPasswordView',
  setup(__props) {

const route = useRoute();
const router = useRouter();
const isKeyValid = ref(false);
const isErrorVerify = ref(false);
const verifyErrorMessage = ref('');
const isLoading = ref(false);

async function onSubmit(values: { password: string }) {
  isLoading.value = true;

  const mailAuthKey = (route?.params?.mailAuthKey ?? '') as string;
  if (!mailAuthKey) {
    router.push({ name: 'cp2mss09' });
    return;
  }

  try {
    const res = await postMailSecurityVerifyWithPassword(mailAuthKey, values.password) as MailSecurityVerifyResponse;
    const resDetail = res?.detail;

    if (resDetail?.isPasswordInvalid) {
      isErrorVerify.value = true;
      verifyErrorMessage.value = errorMessage('PASSWORD_VERIFY_EMAIL') ?? '';
      return;
    }

    if (resDetail?.isKeyExpired) {
      router.replace({ name: 'cp2mss071' });
      return;
    }

    if (resDetail?.isNotExistsKey || resDetail?.isAlreadyAuthen) {
      router.replace({ name: 'cp2mss09' });
      return;
    }

    // success
    localStorage.removeItem('mailSecurityUpdateInfo');
    router.replace({
      name: 'cp2-complete-registration-success',
      query: {
        email: resDetail?.email
      }
    });
  } catch (e) {
    router.replace({ name: 'cp2mss09' });
  } finally {
    isLoading.value = false;
  }
}

onMounted(async () => {
  const mailAuthKey = (route?.params?.mailAuthKey ?? '') as string;
  if (!mailAuthKey) {
    router.push({ name: 'cp2mss09' });
    return;
  }

  try {
    const res = await postMailSecurityCheckKey(mailAuthKey) as MailSecurityVerifyResponse;
    const resDetail = res?.detail;

    if (resDetail?.isKeyExpired) {
      router.replace({ name: 'cp2mss071' });
      return;
    }

    if (resDetail?.isNotExistsKey || resDetail?.isAlreadyAuthen) {
      router.replace({ name: 'cp2mss09' });
      return;
    }

    // key valid -> show form
    isKeyValid.value = true;

    await nextTick();

    // Setup password toggle
    setupPasswordToggle();
  } catch (e) {
    router.replace({ name: 'cp2mss09' });
  }
});

// Setup password toggle
function setupPasswordToggle() {
  const toggleButtons = document.querySelectorAll('.js-toggle-password');
  toggleButtons.forEach((toggleButton) => {
    toggleButton.addEventListener('click', function(e) {
      e.preventDefault();
      const passwordField = toggleButton.parentElement?.querySelector('.js-password-field') as HTMLInputElement;
      if (passwordField) {
        if (passwordField.type === 'password') {
          passwordField.type = 'text';
          toggleButton.classList.add('--is-visible');
        } else {
          passwordField.type = 'password';
          toggleButton.classList.remove('--is-visible');
        }
      }
    });
  });
}

// Clear login error when user tries to submit again
function clearLoginError() {
  isErrorVerify.value = false;
  verifyErrorMessage.value = '';
}

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("main", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        (isKeyValid.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createVNode(_unref(Form), {
                ref: "formRef",
                onSubmit: _cache[0] || (_cache[0] = (values) => onSubmit(values)),
                class: "p-login-form"
              }, {
                default: _withCtx(({ errors }) => [
                  _createElementVNode("div", _hoisted_6, [
                    _createVNode(_unref(ErrorMessage), {
                      as: "p",
                      name: "password",
                      class: "p-login-form__error"
                    }),
                    _hoisted_7,
                    _createVNode(_unref(Field), {
                      "validate-on-blur": false,
                      "validate-on-change": false,
                      "validate-on-input": false,
                      name: "password",
                      id: "verify-password",
                      class: _normalizeClass(["p-login-form__text --is-password js-password-field", { '--is-error': !!errors.password }]),
                      type: "password",
                      label: "マイページパスワード",
                      placeholder: "パスワード（半角英数字）",
                      rules: "required|max:50",
                      maxlength: "50",
                      onInput: clearLoginError
                    }, null, 8, ["class"]),
                    _hoisted_8
                  ]),
                  _withDirectives(_createElementVNode("p", { class: "p-login-form__error" }, _toDisplayString(verifyErrorMessage.value), 513), [
                    [_vShow, isErrorVerify.value]
                  ]),
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("p", _hoisted_10, [
                      _createTextVNode(" ※マイページのパスワードをご入力ください。パスワードが分からない場合は、"),
                      _createVNode(_component_RouterLink, { to: "/pwreregister/form" }, {
                        default: _withCtx(() => [
                          _createTextVNode("こちら")
                        ]),
                        _: 1
                      }),
                      _createTextVNode("から再設定してください。 ")
                    ])
                  ]),
                  _hoisted_11
                ]),
                _: 1
              }, 512)
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createVNode(Loading, { isLoading: isLoading.value }, null, 8, ["isLoading"])
  ]))
}
}

})